
import React from "react";
import { Input } from "@/components/ui/input";
import { Sun } from "lucide-react";

interface CTAButtonProps {
  isEditing: boolean;
  ctaButtonText: string;
  setCtaButtonText: (value: string) => void;
}

export const CTAButton: React.FC<CTAButtonProps> = ({ 
  isEditing, 
  ctaButtonText, 
  setCtaButtonText 
}) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Sun className="h-5 w-5" />
        <h3 className="text-lg font-medium">Bouton CTA</h3>
      </div>
      
      <div className="space-y-4">
        <div className="space-y-2">
          {isEditing ? (
            <div>
              <Input 
                value={ctaButtonText} 
                onChange={(e) => setCtaButtonText(e.target.value)} 
                placeholder="Entrez le texte de votre bouton CTA"
                className="mb-3"
              />
              <div className="p-3 bg-indigo-500 text-white text-center rounded-md">
                {ctaButtonText}
              </div>
            </div>
          ) : (
            <div className="p-3 bg-indigo-500 text-white text-center rounded-md">
              {ctaButtonText}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
